import { useStoreSelector } from 'redux/store';
import { getLicenceExpiry } from '../../../utils/helpers/helpers';

export const useLicenceExpiry = (): string | undefined => {
  const licenceCategory = useStoreSelector((state) => state.licence.licenceCategory);
  return getLicenceExpiry(licenceCategory);
};